export * from './product-full.slice';
